/**
 * Active les sélecteurs d'image natifs utilisés hors du Manager.
 *
 * Le composant conserve un vrai champ fichier pour l'accessibilité et la
 * validation serveur. Le bouton visuel ne fait qu'ouvrir ce champ, montrer
 * immédiatement le fichier choisi puis, lorsque la vue le demande, soumettre
 * son petit formulaire autonome.
 *
 * @param {ParentNode} root Racine dans laquelle initialiser les composants.
 * @returns {void}
 */
export function initializeImagePickers(root = document) {
    root.querySelectorAll('[data-image-picker-form]:not([data-image-picker-ready])').forEach(form => {
        const trigger = form.querySelector('[data-image-picker-trigger]');
        const input = form.querySelector('[data-image-picker-input]');

        // Le déclencheur peut être le bouton HTML historique ou `wa-button`.
        // Dans les deux cas, le champ fichier natif reste le contrôle soumis.
        if (!(trigger instanceof HTMLElement) || !(input instanceof HTMLInputElement)) return;

        form.dataset.imagePickerReady = 'true';
        trigger.addEventListener('click', () => input.click());
        input.addEventListener('change', () => {
            const file = input.files?.[0];
            if (file === undefined) return;

            const previousPreview = trigger.querySelector('[data-image-picker-preview]');
            const preview = previousPreview instanceof HTMLImageElement ? previousPreview : document.createElement('img');
            const objectUrl = URL.createObjectURL(file);

            preview.className = 'image-picker__preview';
            preview.dataset.imagePickerPreview = '';
            preview.alt = `Aperçu de ${file.name}`;
            preview.src = objectUrl;
            preview.addEventListener('load', () => URL.revokeObjectURL(objectUrl), { once: true });
            trigger.querySelector('[data-image-picker-placeholder]')?.replaceWith(preview);

            // Les médias du profil possèdent chacun leur endpoint autonome :
            // choisir un fichier suffit donc à enregistrer le remplacement.
            if (form.hasAttribute('data-image-picker-submit')) form.requestSubmit();
        });
    });
}

document.addEventListener('DOMContentLoaded', () => initializeImagePickers());
